export default __webpack_public_path__ + "72afce49130f28cb6a9475cc400d565c.png";